import type { IconData } from '@stacksjs/iconify-core'

export const handLike: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M24.375 9.15v1.52h-1.52v1.52h1.52v15.24h-3.05v1.52h3.05v1.53h6.1V9.15Zm3.05 6.09h-1.52v-3.05h1.52Zm-6.1-6.09h1.53v1.52h-1.53Zm-1.52-1.53h1.52v1.53h-1.52Zm0 21.33h1.52v1.53h-1.52Zm-1.52-27.42h1.52v6.09h-1.52ZM15.235 0h3.05v1.53h-3.05Zm-9.14 30.48h13.71V32H6.095Zm9.14-19.81h1.52v1.52h-1.52Zm-1.52-9.14h1.52v1.52h-1.52Zm0 7.62h1.52v1.52h-1.52Zm-1.53-6.1h1.53v6.1h-1.53Zm-7.62 9.14h10.67v1.53H4.565Zm6.1 15.24v-1.52h-7.62v3.04h1.52v-1.52zm-6.1 1.52h1.53v1.53h-1.53Zm-1.52-15.23h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M9.135 22.86v-1.52h-6.09v-3.05h6.09v-1.53h-6.09v-1.52h-1.52v10.67h1.52v-3.05z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handLike
